// extracted by mini-css-extract-plugin
module.exports = {"Recommend":"recommend_Recommend__a0guI"};